import { MulticreatorPackageIndexView } from '../types/multicreator_packages';
import { MainV3ApiBase } from './base';

export const MulticreatorPackageApis = {
    index(): Promise<MulticreatorPackageIndexView[]> {
        return MainV3ApiBase.appendPath('multicreator_packages').get();
    },
};
